const GrantaEarthLogo = ({ 
  className = "", 
  size = "md",
  variant = "default" 
}) => {
  const sizeClasses = {
    sm: "h-12",
    md: "h-16", 
    lg: "h-24",
    xl: "h-32",
    xxl: "h-40"
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/grantaearth-logo-official.svg" 
        alt="GrantaEarth Co." 
        className={`${sizeClasses[size]} w-auto ${variant === "white" ? "filter brightness-0 invert" : ""}`}
      />
    </div>
  );
};

export default GrantaEarthLogo;
